import { ChangeEvent, useState } from 'react';
import { Icon, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { RiSearchFill } from 'react-icons/ri';

import { usePageTextContent } from 'context/pageTextContent';

interface Props {
  onChange(value: string): void;
  value: string;
}

export const NearInput = (props: Props) => {
  const { onChange, value } = props;

  const [isFocused, setIsFocused] = useState(false);

  const { content } = usePageTextContent<SearchPageContent>();

  const { searchFieldPlaceholder } = content;

  const onNearInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const onFocus = () => {
    setIsFocused(true);
  };

  const onBlur = () => {
    setIsFocused(false);
  };

  return (
    <InputGroup
      px="2.5rem"
      rounded="lg"
      as={motion.div}
      animate={isFocused ? { scale: 1.05 } : {}}
    >
      <Input
        onFocus={onFocus}
        onBlur={onBlur}
        boxShadow="0px 5px 15px #00000029"
        bg="white"
        py="0.5rem"
        px="1rem"
        onChange={onNearInputChange}
        value={value}
        placeholder={searchFieldPlaceholder}
        _focus={{ boxShadow: 'none' }}
        border="none"
        _placeholder={{
          color: 'gray.550',
          fontWeight: 300,
        }}
      />

      <InputRightElement h="full" w="auto" right="3.5rem">
        <Icon as={RiSearchFill} color="zmyle.primary" fontSize="1.25rem" />
      </InputRightElement>
    </InputGroup>
  );
};
